import './sendMoneyAmountRow.scss'
import type { ReactNode } from 'react'

export const SendMoneyAmountRow = ({
  label,
  value,
  dataTest
}: {
  label: string
  value: string | number | ReactNode
  dataTest?: string
}) => {
  if (!value) return null

  return (
    <div className='send-money-amount-row' data-test={dataTest}>
      <span className='amount-label'>{label}:</span>
      <span className='amount-value'>{value}</span>
    </div>
  )
}
